"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/fr_FR");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "Texte alternatif\xA0:"
  },
  announcement_list_da155734: {
    message: "Liste des annonces"
  },
  announcements_a4b8ed4a: {
    message: "Annonces"
  },
  assignments_1e02582c: {
    message: "T\xE2ches"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "Couleur de fond. Appuyez pour s\xE9lectionner."
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "Annuler l''envoi de fichier"
  },
  cancel_image_upload_2c771950: {
    message: "Annuler l''envoi d''image"
  },
  cc_attribution_f6de631f: {
    message: "Licence CC Paternit\xE9"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "Licence CC Paternit\xE9 Pas de modification"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "Licence CC Paternit\xE9 Pas d\u2019utilisation commerciale"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "Licence CC Paternit\xE9 Pas d\u2019utilisation commerciale Pas de modification"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "Licence CC Paternit\xE9 Pas d\u2019utilisation commerciale Partage \xE0 l\u2019identique"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "Licence CC Paternit\xE9 Partage \xE0 l\u2019identique"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "V\xE9rifier si cette image est d\xE9corative"
  },
  choose_usage_rights_33683854: {
    message: "Choisir les droits d\u2019utilisation..."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "Cliquez sur un fichier pour ins\xE9rer un lien de t\xE9l\xE9chargement pour ce fichier."
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "Cliquez sur une image pour incorporer l\u2019image dans la page."
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "Cliquez sur une page pour ins\xE9rer un lien dans cette page."
  },
  click_to_embed_image_33107dd8: {
    message: "Cliquer pour incorporer une image"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "Cliquer pour incorporer { imageName }"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "Cliquez pour ins\xE9rer un lien dans l''\xE9diteur."
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "Cliquez pour ins\xE9rer un lien vers cet \xE9l\xE9ment."
  },
  close_flickr_form_b32e600a: {
    message: "Fermer le formulaire Flickr"
  },
  collaborations_5c56c15f: {
    message: "Collaborations"
  },
  copyright_holder_66ee111: {
    message: "D\xE9tenteur des droits d\u2019auteur\xA0:"
  },
  course_navigation_dd035109: {
    message: "Barre de navigation des cours"
  },
  creative_commons_license_725584ae: {
    message: "Licence Creative Commons\xA0:"
  },
  decorative_image_fde98579: {
    message: "Image d\xE9corative"
  },
  discussions_a5f96392: {
    message: "Discussions"
  },
  discussions_index_6c36ced: {
    message: "Index des discussions"
  },
  embed_image_1080badc: {
    message: "Incorporer l\u2019image"
  },
  enter_search_terms_e397b1f0: {
    message: "entrer les termes de la recherche"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "Entrez le texte alternatif pour cette image"
  },
  file_upload_form_4aaad554: {
    message: "Formulaire d''envoi de fichier"
  },
  files_c300e900: {
    message: "Fichiers"
  },
  files_index_af7c662b: {
    message: "Index des fichiers"
  },
  folder_705fd2d7: {
    message: "Dossier"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "Taille du texte. Appuyez pour s\xE9lectionner."
  },
  formatting_press_down_to_select_df728c30: {
    message: "Mise en forme. Appuyez pour s\xE9lectionner."
  },
  grades_a61eba0a: {
    message: "Notes"
  },
  group_navigation_99f191a: {
    message: "Barre de navigation des groupes"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "J\u2019ai obtenu l\u2019autorisation d\u2019utiliser ce fichier."
  },
  i_hold_the_copyright_71ee91b1: {
    message: "Je d\xE9tiens les droits d\u2019auteur"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "Si vous ne s\xE9lectionnez pas de droits d''utilisation maintenant, ce fichier sera envoy\xE9 mais non publi\xE9."
  },
  image_upload_form_7b74079a: {
    message: "Formulaire d''envoi d''image"
  },
  images_7ce26570: {
    message: "Images"
  },
  insert_equella_links_49a8dacd: {
    message: "Ins\xE9rer des liens Equella"
  },
  insert_link_6dc23cae: {
    message: "Ins\xE9rer un lien"
  },
  insert_math_equation_57c6e767: {
    message: "Ins\xE9rer une \xE9quation math\xE9matique"
  },
  link_7262adec: {
    message: "Lien"
  },
  link_to_a_new_page_6c4ad034: {
    message: "Lien vers une nouvelle page"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "Lier \xE0 un autre contenu du cours."
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "Lier \xE0 un autre contenu du groupe."
  },
  link_to_url_52dd935c: {
    message: "Lien vers l''URL"
  },
  links_14b70841: {
    message: "Liens"
  },
  load_more_results_460f49a9: {
    message: "Charger plus de r\xE9sultats"
  },
  loading_25990131: {
    message: "Chargement..."
  },
  loading_failed_b3524381: {
    message: "\xC9chec du chargement..."
  },
  loading_folders_8d4d5d5a: {
    message: "Chargement des dossiers..."
  },
  modules_c4325335: {
    message: "Modules"
  },
  no_results_940393cf: {
    message: "Aucun r\xE9sultat."
  },
  pages_e5414c2c: {
    message: "Pages"
  },
  people_b4ebb13c: {
    message: "Personnes"
  },
  quizzes_7e598f57: {
    message: "Questionnaires"
  },
  record_upload_media_5fdce166: {
    message: "Enregistrement\xA0/\xA0T\xE9l\xE9chargement de m\xE9dia"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "Zone de texte enrichi. Presser ALT+F8 pour obtenir de l''aide"
  },
  search_280d00bd: {
    message: "Chercher"
  },
  search_flickr_6884b518: {
    message: "Rechercher sur Flickr"
  },
  select_a_file_53ba40ac: {
    message: "S\xE9lectionnez un fichier"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "S\xE9lectionner un dossier vers lequel envoyer votre fichier"
  },
  syllabus_f191f65b: {
    message: "Programme"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "Couleur du texte. Appuyez pour s\xE9lectionner."
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "Ce contenu appartient au domaine public"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "Ce contenu est couvert par une licence Creative Commons"
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "Ce contenu est soumis \xE0 une exception pour l\u2019usage loyal"
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "Ce t\xE9l\xE9chargement d\xE9passe le quota de stockage de fichiers. Veuillez vous adresser \xE0 votre administrateur syst\xE8me."
  },
  upload_8b403d05: {
    message: "T\xE9l\xE9charger"
  },
  upload_a_new_file_96e6d4ff: {
    message: "T\xE9l\xE9charger un nouveau fichier"
  },
  upload_a_new_image_890df275: {
    message: "T\xE9l\xE9charger une nouvelle image"
  },
  usage_right_ff96f3e2: {
    message: "Droit d\u2019utilisation\xA0:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "Comment voulez-vous nommer la nouvelle page\xA0?"
  },
  wiki_home_9cd54d0: {
    message: "Page d\u2019accueil de Wiki"
  }
};

_formatMessage.default.addLocale({
  fr: locale
});